import styles from "components/Form/Form.module.scss";

export const formConfig = {
  name: {
    title: "Queue Name",
    elementType: "input",
    elementConfig: {
      id: "name",
      type: "text",
      value: "",
      placeholder: "Enter queue name",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: true },
    valid: false,
    touched: false,
    error: { message: "Queue name is required" },
  },
  "parameters.discard-abandoned-after": {
    title: "Discard Abandoned After (seconds)",
    elementType: "input",
    elementConfig: {
      id: "parameters.discard-abandoned-after",
      type: "number",
      value: "",
      placeholder: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: false,
    touched: false,
    error: { message: "This field is required" },
  },
  "parameters.max-wait-time": {
    title: "Max Wait Time",
    elementType: "input",
    elementConfig: {
      id: "parameters.max-wait-time",
      type: "number",
      value: "0",
      placeholder: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: false,
    touched: false,
    error: { message: "This field is required" },
  },
  "parameters.max-wait-time-with-no-agent": {
    title: "Max Wait Time (No Agent)",
    elementType: "input",
    elementConfig: {
      id: "parameters.max-wait-time-with-no-agent",
      type: "number",
      value: "",
      placeholder: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: false,
    touched: false,
    error: { message: "This field is required" },
  },
  "parameters.moh-sound": {
    title: "Music on Hold Sound Path",
    elementType: "file",
    elementConfig: {
      id: "parameters.moh-sound",
      type: "file",
      accept: ".wav",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.file,],
    validation: {
      required: false,
    },
    valid: false,
    touched: false,
    error: { message: "An audio file is required" },
  },
  "parameters.strategy": {
    title: "Strategy",
    elementType: "input",
    elementConfig: {
      id: "parameters.strategy",
      type: "text",
      value: "ring-progressively",
      placeholder: "",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
  },
  "parameters.tier-rule-no-agent-no-wait": {
    title: "Tier Rule: No Agent No Wait",
    elementType: "select",
    elementConfig: {
      id: "parameters.tier-rule-no-agent-no-wait",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    options: [
      { value: "", text: "-- select --" },
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    error: {
      message: "",
    },
  },
  "parameters.tier-rule-wait-multiply-level": {
    title: "Tier Rule: Wait Multiply Level",
    elementType: "select",
    elementConfig: {
      id: "parameters.tier-rule-wait-multiply-level",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    options: [
      { value: "", text: "-- select --" },
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    error: {
      message: "",
    },
  },
  "parameters.tier-rule-wait-second": {
    title: "Tier Rule Wait Seconds",
    elementType: "input",
    elementConfig: {
      id: "parameters.tier-rule-wait-second",
      type: "number",
      value: "300",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
  },
  "parameters.tier-rules-apply": {
    title: "Apply Tier Rules",
    elementType: "select",
    elementConfig: {
      id: "parameters.tier-rules-apply",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    options: [
      { value: "", text: "-- select --" },
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    error: {
      message: "",
    },
  },
  "parameters.time-base-score": {
    title: "Time Base Score",
    elementType: "input",
    elementConfig: {
      id: "parameters.time-base-score",
      type: "text",
      value: "queue",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
  },
  description: {
    title: "Description",
    elementType: "textarea",
    elementConfig: {
      id: "description",
      value: "This is a sample queue",
      placeholder: "Enter a description for the queue",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: { required: false },
    valid: true,
    touched: false,
  },
  enabled: {
    title: "Enabled",
    elementType: "select",
    elementConfig: {
      id: "enabled",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.select],
    validation: {
      required: false,
    },
    valid: true,
    touched: false,
    options: [
      { value: "", text: "-- set enabled --" },
      { value: "false", text: "No" },
      { value: "true", text: "Yes" },
    ],
    error: {
      message: "",
    },
  },
  domain_id: {
    title: "Domain",
    elementType: "input",
    elementConfig: {
      id: "domain_id",
      type: "text",
      value: "",
      placeholder: "Search and select a domain",
      autoComplete: "off",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: true,
    },
    valid: false,
    touched: false,
    dropdown: true,
    error: {
      message: "Domain is required",
    },
  },
};
